export default {
    cn: {
        profitTopList: {
            excelName: '盈利Top榜',
            startTime: '开始日期',
            endTime: '结束日期',
            profitType: { 'weekly': '周结', 'monthly': '月结', 'daily': '日结' },
            topTxt: 'Top榜前',
            profitTypeTxt: '盈利类型：',
            downloadTxt: '下载Excel',
            searchTxt: '搜 索',
            tableHead: [
                { key: 'LOGIN', value: '客户账号' },
                { key: 'NAME', value: '客户姓名' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'OFFICE_NAME', value: '所属办事处' },
                { key: 'ACC_NAME', value: '地区' }
            ],
            weekly: [
                { key: 'FLOATING_THIS_WEEK', value: '今周相对浮动' },
                { key: 'FLOATING_THIS_MONTH', value: '今月相对浮动' },
                { key: 'CLOSED_PL_THIS_WEEK', value: '今周平仓盈亏' },
                { key: 'CLOSED_PL_THIS_MONTH', value: '今月平仓盈亏' },
                { key: 'CLOSED_LOTS_THIS_WEEK', value: '今周平仓手数' },
                { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平仓手数' },
                { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' },
                { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' },
                { key: 'EQUITY_THIS_MONTH', value: '出入金净值' },
            ],
            monthly: [
                { key: 'FLOATING_THIS_MONTH', value: '今月相对浮动' },
                { key: 'CLOSED_PL_THIS_MONTH', value: '今月平仓盈亏' },
                { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平仓手数' },
                { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' },
                { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' },
                { key: 'EQUITY_THIS_MONTH', value: '出入金净值' },
            ],
            daily: [
                { key: 'FLOATING_TODAY', value: '今日相对浮动' },
                { key: 'FLOATING_THIS_MONTH', value: '今月相对浮动' },
                { key: 'CLOSED_PL_TODAY', value: '今日平仓盈亏' },
                { key: 'CLOSED_PL_THIS_MONTH', value: '今月平仓盈亏' },
                { key: 'CLOSED_LOTS_TODAY', value: '今日平仓手数' },
                { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平仓手数' },
                { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' },
                { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' },
                { key: 'EQUITY_THIS_MONTH', value: '出入金净值' },
            ],
        }
    },
    hk: {
        profitTopList: {
            excelName: '盈利Top榜',
            startTime: '開始日期',
            endTime: '結束日期',
            profitType: { 'weekly': '周結', 'monthly': '月結', 'daily': '日結' },
            topTxt: 'Top榜前',
            profitTypeTxt: '盈利類型：',
            downloadTxt: '下載Excel',
            searchTxt: '搜 索',
            tableHead: [
                { key: 'LOGIN', value: '客戶賬號' },
                { key: 'NAME', value: '客戶姓名' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'OFFICE_NAME', value: '所屬辦事處' },
                { key: 'ACC_NAME', value: '地區' }
            ],
            weekly: [
                { key: 'FLOATING_THIS_WEEK', value: '今周相對浮動' },
                { key: 'FLOATING_THIS_MONTH', value: '今月相對浮動' },
                { key: 'CLOSED_PL_THIS_WEEK', value: '今周平倉盈虧' },
                { key: 'CLOSED_PL_THIS_MONTH', value: '今月平倉盈虧' },
                { key: 'CLOSED_LOTS_THIS_WEEK', value: '今周平倉手數' },
                { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平倉手數' },
                { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' },
                { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' },
                { key: 'EQUITY_THIS_MONTH', value: '出入金淨值' },
            ],
            monthly: [
                { key: 'FLOATING_THIS_MONTH', value: '今月相對浮動' },
                { key: 'CLOSED_PL_THIS_MONTH', value: '今月平倉盈虧' },
                { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平倉手數' },
                { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' },
                { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' },
                { key: 'EQUITY_THIS_MONTH', value: '出入金淨值' },
            ],
            daily: [
                { key: 'FLOATING_TODAY', value: '今日相對浮動' },
                { key: 'FLOATING_THIS_MONTH', value: '今月相對浮動' },
                { key: 'CLOSED_PL_TODAY', value: '今日平倉盈虧' },
                { key: 'CLOSED_PL_THIS_MONTH', value: '今月平倉盈虧' },
                { key: 'CLOSED_LOTS_TODAY', value: '今日平倉手數' },
                { key: 'CLOSED_LOTS_THIS_MONTH', value: '今月平倉手數' },
                { key: 'DEPOSIT_THIS_MONTH', value: '今月入金' },
                { key: 'WITHDRAWAL_THIS_MONTH', value: '今月出金' },
                { key: 'EQUITY_THIS_MONTH', value: '出入金淨值' },
            ],
        }
    },
    en: {
        profitTopList: {
            excelName: 'Profit Top List',
            startTime: 'Start Date',
            endTime: 'End Date',
            profitType: { 'weekly': 'Weekly', 'monthly': 'Monthly', 'daily': 'Daily' },
            topTxt: 'Top',
            profitTypeTxt: 'Profit Type：',
            downloadTxt: 'Download Excel',
            searchTxt: 'Search',
            tableHead: [
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'IB Account' },
                { key: 'OFFICE_NAME', value: 'Office Name' },
                { key: 'ACC_NAME', value: 'Region Name' }
            ],
            weekly: [
                { key: 'FLOATING_THIS_WEEK', value: 'Floating This Week' },
                { key: 'FLOATING_THIS_MONTH', value: 'Floating This Month' },
                { key: 'CLOSED_PL_THIS_WEEK', value: 'Closed PL This Week' },
                { key: 'CLOSED_PL_THIS_MONTH', value: 'Closed PL This Month' },
                { key: 'CLOSED_LOTS_THIS_WEEK', value: 'Closed Lots This Week' },
                { key: 'CLOSED_LOTS_THIS_MONTH', value: 'Closed Lots This Month' },
                { key: 'DEPOSIT_THIS_MONTH', value: 'Deposit This Month' },
                { key: 'WITHDRAWAL_THIS_MONTH', value: 'Withdrawal This Month' },
                { key: 'EQUITY_THIS_MONTH', value: 'Equity This Month' },
            ],
            monthly: [
                { key: 'FLOATING_THIS_MONTH', value: 'Floating This Month' },
                { key: 'CLOSED_PL_THIS_MONTH', value: 'Closed PL This Month' },
                { key: 'CLOSED_LOTS_THIS_MONTH', value: 'Closed Lots This Month' },
                { key: 'DEPOSIT_THIS_MONTH', value: 'Deposit This Month' },
                { key: 'WITHDRAWAL_THIS_MONTH', value: 'Withdrawal This Month' },
                { key: 'EQUITY_THIS_MONTH', value: 'Equity This Month' },
            ],
            daily: [
                { key: 'FLOATING_TODAY', value: 'Floating Today' },
                { key: 'FLOATING_THIS_MONTH', value: 'Floating This Month' },
                { key: 'CLOSED_PL_TODAY', value: 'Closed PL Today' },
                { key: 'CLOSED_PL_THIS_MONTH', value: 'Closed PL This Month' },
                { key: 'CLOSED_LOTS_TODAY', value: 'Closed Lots Today' },
                { key: 'CLOSED_LOTS_THIS_MONTH', value: 'Closed Lots This Month' },
                { key: 'DEPOSIT_THIS_MONTH', value: 'Deposit This Month' },
                { key: 'WITHDRAWAL_THIS_MONTH', value: 'Withdrawal This Month' },
                { key: 'EQUITY_THIS_MONTH', value: 'Equity This Month' },
            ],
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/profitTopList.js